// Color de StatusBadge según el nombre del estado. Las claves van normalizadas
// (minúsculas, sin acentos); los estados no listados quedan en gris.
const STATUS_COLORS = {
  // Completados o vigentes
  activo: "success",
  activa: "success",
  aprobado: "success",
  aprobada: "success",
  autorizado: "success",
  autorizada: "success",
  preautorizada: "success",
  adjudicada: "success",
  completado: "success",
  completada: "success",
  despachado: "success",
  despachada: "success",
  auditada: "success",
  entregada: "success",
  cobrada: "success",
  facturada: "success",
  pagado: "success",
  pagada: "success",
  aceptado: "success",
  aceptada: "success",
  vigente: "success",
  registrado: "success",
  "de alta": "success",

  // En curso
  emitido: "info",
  emitida: "info",
  generada: "info",
  abierta: "info",
  enviado: "info",
  enviada: "info",
  "enviada a auditoria": "info",
  recibida: "info",
  procesada: "info",
  programada: "info",
  "en proceso": "info",
  "en consulta": "info",
  "iniciar consulta": "info",
  "espera de propuestas": "info",
  "firma de contrato": "info",
  "en caja": "primary",
  registrada: "primary",

  // Requieren atención
  pendiente: "warning",
  "despachada parcialmente": "warning",
  objetada: "warning",
  suspendido: "warning",
  suspendida: "warning",
  pospuesta: "warning",
  "re-agendada": "warning",
  "declarada desierta": "warning",
  "validacion de documentacion": "warning",

  // Finalizados sin éxito
  cancelado: "danger",
  cancelada: "danger",
  rechazado: "danger",
  rechazada: "danger",
  denegada: "danger",
  anulado: "danger",
  anulada: "danger",
  eliminada: "danger",
  "dado de baja": "danger",

  // Cerrados o inactivos
  vencido: "secondary",
  vencida: "secondary",
  cerrada: "secondary",
  inactivo: "secondary",
  inactiva: "secondary",
  "fin de consulta": "secondary",
};

export const normalizeStatusName = (name) =>
  String(name ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();

export const getStatusColor = (name) =>
  STATUS_COLORS[normalizeStatusName(name)] || "secondary";
